export default __webpack_public_path__ + "static/media/saveXMLIcon.7dc2ceca.svg";